const brandDomains = [ 
	{
		domain: 'www.yolo247.site',
		id: 31,
		type: 'CLIENT',
		dev: 'PROD'
	},
	{
		domain: 'www.yolo247.co',
		id: 31,
		type: 'CLIENT',
		dev: 'PROD'
	},
	{
		domain: 'www.yolo247.site',
		id: 31,
		type: 'CLIENT',
		dev: 'PROD'
	},
	{
		domain: 'www.yolo247.live',
		id: 31,
		type: 'CLIENT',
		dev: 'PROD'
	},
	{
		domain: 'www.yolo247in.live',
		id: 31,
		type: 'CLIENT',
		dev: 'PROD'
	},
	{
		domain: 'www.yolo247.com',
		id: 31,
		type: 'CLIENT',
		dev: 'PROD'
	},
	{
		domain: 'www.yolo247experience.co',
		id: 31,
		type: 'CLIENT',
		dev: 'PROD'
	},
	{
		domain: 'www.yolo247experience.com',
		id: 31,
		type: 'CLIENT',
		dev: 'PROD'
	},
	{
		domain: 'www.yolo247.net',
		id: 31,
		type: 'CLIENT',
		dev: 'PROD'
	},

	{
		domain: 'www.yowo247.com',
		id: 31,
		type: 'CLIENT',
		dev: 'PROD'
	},

	{
		domain: 'cashsite.gamestest.link',
		id: 31,
		type: 'CLIENT/AGENT',
		dev: 'STAGING'
	},
	{
		domain: 'cashsite2.gamestest.link',
		id: 31,
		type: 'CLIENT/AGENT',
		dev: 'STAGING'
	},
	{
		domain: 'preprod.yolo247.com',
		id: 31,
		type: 'CLIENT',
		dev: 'PRE-PROD'
	},
	{
		domain: 'preprod.yolo247.site',
		id: 31,
		type: 'CLIENT',
		dev: 'PRE-PROD'
	},
	{
		domain: 'preprod.yolo247.co',
		id: 31,
		type: 'CLIENT',
		dev: 'PRE-PROD'
	},
	{
		domain: 'preprod.yolo247.net',
		id: 31,
		type: 'CLIENT',
		dev: 'PRE-PROD'
	},
	{
		domain: 'preprod.yolo247.live',
		id: 31,
		type: 'CLIENT',
		dev: 'PRE-PROD'
	},
	{
		domain: 'www.yolo247.club',
		id: 32,
		type: 'CLIENT',
		dev: 'PROD'
	},
	{
		domain: 'preprod.yolo247.club',
		id: 32,
		type: 'CLIENT',
		dev: 'PRE-PROD'
	},

	{
		domain: 'www.yolo247club.co',
		id: 32,
		type: 'CLIENT',
		dev: 'PROD'
	},
	{
		domain: 'www.yolo247club.com',
		id: 32,
		type: 'CLIENT',
		dev: 'PROD'
	},


	{
		domain: 'a-cashsite.gamestest.link',
		id: 32,
		type: 'CLIENT',
		dev: 'STAGING'
	},

    //betdaily whitelabel brandid 33
	{
		domain: 'www.iw247.com',
		id: 33,
		type: 'CLIENT',
		dev: 'PROD'
	},
	{
		domain: 'www.baaziadda.co',
		id: 33,
		type: 'CLIENT',
		dev: 'PROD'
	},{
		domain: 'www.baaziadda.net',
		id: 33,
		type: 'CLIENT',
		dev: 'PROD'
	},


	{
		domain: 'betdaily.gamestest.link',
		id: 33,
		type: 'CLIENT',
		dev: 'STAGING'
	},
	{
		domain: 'preprod.iw247.com',
		id: 33,
		type: 'CLIENT',
		dev: 'PRE-PROD'
	},



	///betdaily whitelabel brandid 31 
	{
		domain: 'www.betdaily.club',
		id: 34,
		type: 'CLIENT',
		dev: 'PROD'
	},
	{
		domain: 'club-betdaily.gamestest.link',
		id: 34,
		type: 'CLIENT',
		dev: 'STAGING' 
	},
	{
		domain: 'preprod.betdaily.club',
		id: 34,
		type: 'CLIENT',
		dev: 'PRE-PROD'
	},


	///////// fomo7 whitelabel brandid 39 


	{
		domain: 'www.fomo7.com',
		id: 39,
		type: 'CLIENT',
		dev: 'PROD'
	},
	{
		domain: 'www.fomo7.net',
		id: 39,
		type: 'CLIENT',
		dev: 'PROD'
	},
	{
		domain: 'www.fomo7.co',
		id: 39,
		type: 'CLIENT',
		dev: 'PROD'
	},
	{
		domain: 'www.7fomo.net',
		id: 39,
		type: 'CLIENT',
		dev: 'PROD'
	},
	{
		domain: 'www.7fomo.co',
		id: 39,
		type: 'CLIENT',
		dev: 'PROD'
	},
	{
		domain: 'www.foma7.com',
		id: 39,
		type: 'CLIENT',
		dev: 'PROD'
	},
	{
		domain: 'fomo7.gamestest.link',
		id: 39,
		type: 'CLIENT',
		dev: 'STAGING' 
	},
	{
		domain: 'preprod.fomo7.com',
		id: 39,
		type: 'CLIENT',
		dev: 'PRE-PROD'
	},

	///////// fomo7 Club whitelabel brandid 40


		{
			domain: 'www.fomo7.xyz',
			id: 40,
			type: 'CLIENT',
			dev: 'PROD'
		},
		{
			domain: 'www.fomo7.pro',
			id: 40,
			type: 'CLIENT',
			dev: 'PROD'
		},
		{
			domain: 'www.fomo7.club',
			id: 40,
			type: 'CLIENT',
			dev: 'PROD'
		},
		{
			domain: 'club-fomo7.gamestest.link',
			id: 40,
			type: 'CLIENT',
			dev: 'STAGING' 
		},
		{
			domain: 'preprod.fomo7.xyz',
			id: 40,
			type: 'CLIENT',
			dev: 'PRE-PROD'
		},
	
	///////// fun.bbb365 club whitelabel brandid 46

	/////////// Don't forgot to add new domain names to public/index.html file for fun88 theme-white. ************** */
	{
		domain: 'www.fun88.site',
		id: 46,
		type: 'CLIENT',
		dev: 'PROD'
	},
	{
		domain: 'preprod.fun88.site',
		id: 46,
		type: 'CLIENT',
		dev: 'PRE-PROD'
	},
	{
		domain: 'club-fun.gamestest.link',
		id: 46,
		type: 'CLIENT',
		dev: 'STAGING' 
	},

	///////// fun.bbb365 com whitelabel brandid 47
	{
		domain: 'www.fun88.online',
		id: 47,
		type: 'CLIENT',
		dev: 'PROD'
	},
	{
		domain: 'preprod.fun88.online',
		id: 47,
		type: 'CLIENT',
		dev: 'PRE-PROD'
	},
	{
		domain: 'fun88.gamestest.link',
		id: 47,
		type: 'CLIENT',
		dev: 'STAGING' 
	},

	{
		domain: 'www.gofun88.in',
		id: 47,
		type: 'CLIENT',
		dev: 'PROD'
	},
	{
		domain: 'www.fun88ind.com',
		id: 47,
		type: 'CLIENT',
		dev: 'PROD'
	},
	{
		domain: 'preprod.gofun88.in',
		id: 47,
		type: 'CLIENT',
		dev: 'PRE-PROD'
	},

	{
		domain: 'www.fun88ind.com',
		id: 47,
		type: 'CLIENT',
		dev: 'PROD',
		name:'Fun88'
	},

	{
		domain: 'www.88funinr.com',
		id: 47,
		type: 'CLIENT',
		dev: 'PROD'
	},

	{
		domain: 'www.fun88casinoindia.com',
		id: 47,
		type: 'CLIENT',
		dev: 'PROD'
	},


	//////local host//////

	{
		domain: 'localhost:3000',
		id: 31,
		type: 'CLIENT/AGENT',
		dev: 'DEV'
	},
];

 
export default brandDomains;